import { render } from "./Buscar.vue?vue&type=template&id=043634f9"
import script from "./Buscar.vue?vue&type=script&lang=js"
export * from "./Buscar.vue?vue&type=script&lang=js"
script.render = render

export default script